export function useScrollCenter(selector: string, containerSelector?: string) {
  const { scrollToCenter } = useScrollToCenter();

  useEffect(() => {
    const target = document.querySelector(selector) as HTMLElement;
    if (!target) return;

    const container = containerSelector
      ? (document.querySelector(containerSelector) as HTMLElement)
      : (target.parentElement as HTMLElement);

    if (target && container) {
      scrollToCenter(target, container);
    }
  }, [selector, containerSelector, scrollToCenter]);
}
